import styled from 'styled-components/macro';

import palette from 'palette';

export const StyledContent = styled.div`
  margin: 24px;
  padding: 24px;
  background-color: ${palette.white.w1};
`;
